import React from 'react';
import AnsibleHostDetail from './AnsibleHostDetail';

const WrappedAnsibleHostDetail = props => <AnsibleHostDetail {...props} />;

export default WrappedAnsibleHostDetail;



// WEBPACK FOOTER //
// ./vendor/ruby/2.7.0/gems/foreman_ansible-12.0.6/webpack/components/AnsibleHostDetail/index.js